import {
  faChartPie, faTable,
} from '@fortawesome/pro-solid-svg-icons';
import { useMemo } from 'react';
import type { GroupButtonItem } from '~/_shared/baseComponents/buttons';
import { CONFIG } from '~/_shared/constants/config';
import { useIsMobileScreenSelector } from '~/store/frontendState/deviceInfo/deviceInfo.selector';
import { useMapIdSelector } from '~/store/selectors/useMapIdSelector';
import { useSplitPanelState } from '~/store/userData/settings/splitPanel/useSplitPanelState';
import { MapPageSplitScreenTab } from './mapPageSplitScreen.types';
import { MapPageSplitScreenGutterComponent } from './mapPageSplitScreenGutterComponent';
import { useMapPageChartItems } from './useMapPageChartItems';

type MapPageSplitScreenGutterContainerProps = Readonly<{
  onClose: () => void;
}>;

export const MapPageSplitScreenGutterContainer = ({
  onClose,
}: MapPageSplitScreenGutterContainerProps) => {
  const mapId = useMapIdSelector();
  const isMobileScreen = useIsMobileScreenSelector();
  const { tab, onTabChange } = useSplitPanelState(mapId);
  const { chartItems, onAddNewChart } = useMapPageChartItems();

  const availableCharts = (chartItems.length > 0 || onAddNewChart) && CONFIG.ENABLE_CHARTS;

  const tabs: GroupButtonItem<MapPageSplitScreenTab>[] = useMemo(() => [{
    id: MapPageSplitScreenTab.Spreadsheet,
    icon: faTable,
    disabledMessage: null,
    onClick: () => onTabChange(MapPageSplitScreenTab.Spreadsheet),
    text: 'Data',
  }, {
    id: MapPageSplitScreenTab.Chart,
    icon: faChartPie,
    disabledMessage: null,
    onClick: () => onTabChange(MapPageSplitScreenTab.Chart),
    text: 'Charts',
  }], [onTabChange]);

  return (
    <MapPageSplitScreenGutterComponent
      tabsItems={availableCharts ? tabs : []}
      selectedTab={availableCharts ? tab : MapPageSplitScreenTab.Spreadsheet}
      isMobileScreen={isMobileScreen}
      onClose={onClose}
    />
  );
};
